import { useMemo } from 'react';
import {
    useMixedGroupedTournamentsStoreCreator,
} from '../mixed-grouped.store';
import { replaceTopicPlaceholders } from '@om-fe/utils';
import { TOPIC_LOCATION_TOURNAMENTS } from '@om-fe/core/components/grouped-match-list/store/grouped-match-list.constants';

export function useMixedGroupedLocationStoreCreator(sportId: string, locationId: string) {
    const topic: string = useMemo((): string => replaceTopicPlaceholders(
        TOPIC_LOCATION_TOURNAMENTS,
        { disciplineId: sportId, locationId },
    ), [locationId, sportId]);

    return useMixedGroupedTournamentsStoreCreator(topic);
}
